import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  inputData: '{}',
};

export default defaults;
